import { colorCardPage } from './color_card';
import { productTypesPage } from './product_types';
import { smallCutsPage } from './small_cuts';

global.colorCardPage = colorCardPage;
global.productTypesPage = productTypesPage;
global.smallCutsPage = smallCutsPage;
